// extracted by mini-css-extract-plugin
export default {"bar":"NotificationBar_bar__m4QcI","default":"NotificationBar_default__XuOrA","lake":"NotificationBar_lake__GhrtA"};